




























































# import settings from '@/settings'
import pro_hazards_table from '@/components/tables/pro_hazards_table'
import Menus from '@/components/menus'
import af from '@/utils/authorized_formats'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import FileUpload from '@/components/file_upload'



export default {
    name: 'company_pro_hazards'

    components: { pro_hazards_table, Menus, FileUpload }

    data: ()->
        reload: true
        errors: {}
        active_names: [1]
        readonly: false
        max_filesize: af['pro_hazard']['file']['max_filesize']/1024/1024
        authorized_formats: af['pro_hazard']['file']['authorized_formats']
        picker_options: {firstDayOfWeek:1}
        pro_hazard: {
            company_uid: ''
            file_data: ''
            file_name: ''
            uid: ''
            comment: ''
            date: ''
        }
        
    computed:
        toggle_collapse_text: ()->
            text = "Ajouter un document"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        selected: (pro_h)->
            console.log("pro_h", pro_h)
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0            
            @pro_hazard = pro_h
            @pro_hazard['file_name'] = pro_h.file
        has_access_right: t.has_access_right

        reset_pro_hazard: ()->
            @pro_hazard = {
                company_uid: ''
                #file_data: ''
                file_name: ''
                uid: ''
                date: ''
            }
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_pro_hazard()
            #@$refs.pro_hazard_upload.clearFiles()
            return

        handle_file_remove: (file, fileList)->
            #@$refs.pro_hazard_upload.clearFiles()
            @pro_hazard.file_data = ''
            @pro_hazard.file_name = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['pro_hazard']['file']['mime_types']
            is_good_size = file.size < af['pro_hazard']['file']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.pro_hazard.file_data = e.target.result
                self.pro_hazard.file_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @pro_hazard
            return

        delete_pro_hazard: (pro_hazard_id)->
            # console.log  "DELETE PRO_HAZARD", pro_hazard_id
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce document ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "PRO_HAZARD DELETE", pro_hazard_id
                    m.run('delete_object', ['pro_hazard', pro_hazard_id])
                    .then (resp)->
                        # console.log "DELETE PRO_HAZARD DUTY", resp.body.data.pro_hazard_deletion
                        if resp.body.data.pro_hazard_deletion.ok
                            n.success()
                            self.reload = !self.reload
                            self.reset_pro_hazard()
                            self.active_names = [1]
                        else
                            n.gql_error("company_pro_hazards: delete_pro_hazard: then", resp.body.data.pro_hazard_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_pro_hazards: delete_pro_hazard()")
                .catch (cancel)->
                    return

        save: ()->
            # console.log "SAVE PRO_HAZARD", @pro_hazard
            self = @
            @pro_hazard.company_uid = @$store.getters.current_company.uid
            @pro_hazard.date = @pro_hazard.date.split("T")[0]
            m.run('save_pro_hazard', [@pro_hazard])
            .then (resp)->
                if resp.body.data.pro_hazard_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.pro_hazard_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.pro_hazard_form_mutation.errors
                    self.errors = resp.body.data.pro_hazard_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    await self.$refs.file_upload.save_from_parent(
                      resp.body.data.pro_hazard_form_mutation.form_ret)
                    self.$refs.file_upload.clearTmpFiles()
                    n.success()
                    self.reset_pro_hazard()
                    self.active_names = [1]
                    #self.$refs.pro_hazard_upload.clearFiles()
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "company_pro_hazards: save()")

    # mounted: ()->
}
